import { memo } from "react";
import {
  ChatCloseIcon,
  ChatExpandIcon,
  ChatHistoryIcon,
  ChatPlusIcon,
  ChatSparkleIcon,
} from "components/shared/svg-action-icons";

const ChatHeader = ({
  t,
  variant = "compact",
  isHistoryOpen,
  onNewChat,
  onToggleHistory,
  onExpand,
  onClose,
}) => {
  const isCompact = variant === "compact";

  if (isCompact) {
    return (
      <div className="chat-header bg-chrome-raised text-surface h-[68px] px-[20px] flex items-center justify-between flex-shrink-0 z-10">
        <div className="flex items-center gap-3">
          <div className="w-[34px] h-[34px] rounded-full bg-primary/35 flex items-center justify-center">
            <ChatSparkleIcon className="w-4 h-4 text-white" />
          </div>
          <div className="flex flex-col text-start">
            <span className="text-[14px] font-bold leading-tight">
              {t("chat.title")}
            </span>
            <span className="text-[11px] text-success flex items-center gap-1 mt-0.5">
              <span className="w-1.5 h-1.5 bg-success rounded-full inline-block" />
              {t("chat.online")}
            </span>
          </div>
        </div>

        <div className="flex items-center gap-3">
          <button
            type="button"
            onClick={onNewChat}
            title={t("chat.add")}
            className="p-1.5 text-white/80 hover:text-white rounded-md hover:bg-white/10 transition"
          >
            <ChatPlusIcon />
          </button>
          <button
            type="button"
            onClick={onToggleHistory}
            title={t("chat.thread_history")}
            className={`p-1.5 text-white/80 hover:text-white rounded-md hover:bg-white/10 transition ${
              isHistoryOpen ? "bg-white/20 text-white" : ""
            }`}
          >
            <ChatHistoryIcon />
          </button>
          {onExpand && (
            <button
              type="button"
              onClick={onExpand}
              className="p-1.5 text-white/80 hover:text-white rounded-md hover:bg-white/10 transition"
            >
              <ChatExpandIcon />
            </button>
          )}
          <button
            type="button"
            onClick={onClose}
            className="p-1.5 text-white/80 hover:text-white rounded-md hover:bg-white/10 transition"
          >
            <ChatCloseIcon />
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-chrome-raised text-surface h-16 md:h-20 px-6 flex items-center justify-between flex-shrink-0 border-b border-surface/5">
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 rounded-full bg-primary/35 flex items-center justify-center flex-shrink-0 shadow-md">
          <ChatSparkleIcon className="w-5 h-5 text-white" />
        </div>
        <div className="flex flex-col text-start">
          <span className="text-sm md:text-base font-bold leading-tight">
            {t("chat.title")}
          </span>
          <span className="text-[11px] md:text-xs text-success flex items-center gap-1.5 mt-0.5">
            <span className="w-2 h-2 bg-success rounded-full inline-block" />
            {t("chat.online")}
          </span>
        </div>
      </div>

      <div className="flex items-center gap-4">
        <button
          type="button"
          onClick={onNewChat}
          className="px-4 text-white text-xs font-semibold h-9 bg-primary hover:bg-primary/90 rounded-full flex items-center gap-1.5 transition shadow-sm"
        >
          <ChatPlusIcon className="w-4 h-4" />
          <span>{t("chat.add")}</span>
        </button>
        <button
          type="button"
          onClick={onToggleHistory}
          className={`flex items-center gap-1.5 px-3 rounded-full h-9 font-semibold text-xs transition border ${
            isHistoryOpen
              ? "bg-white/10 border-white/20 text-white"
              : "bg-surface text-chrome-raised border-transparent hover:bg-surface-muted"
          }`}
        >
          <ChatHistoryIcon className="w-4 h-4" />
          <span>{t("chat.thread_history")}</span>
        </button>
        <button
          type="button"
          onClick={onClose}
          className="p-2 text-white/80 hover:text-white hover:bg-white/10 rounded-md transition"
        >
          <ChatCloseIcon className="w-6 h-6" />
        </button>
      </div>
    </div>
  );
};

export default memo(ChatHeader);
